import { Card } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import AppTracking from "../../../app/assets/images/apptracking.png";
import Scheduling from "../../../app/assets/images/scheduling.png";
import OfferLetter from "../../../app/assets/images/offerLetter.png";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const RecruitmentCard = ({ isVisible }) => {
  const navigate = useNavigate();

  return (
    <div className="recruitment-container">
      <Card
        className="recruitment-card cursor-pointer transition-all duration-300 hover:scale-105 hover:bg-[#f78d2e] hover:shadow-xl"
        onClick={() => {
          navigate(`applicant-tracking`);
        }}
      >
        <button className="modalBtn">
          <EllipsisOutlined className="dropdownIcon" />
        </button>
        <div className="flex flex-col items-center">
          <img src={AppTracking} alt="Your Logo" className="icon" />
          <div>
            <p className="cardDes font-bold text-xl">Applicant Tracking</p>
          </div>
        </div>
      </Card>
      <Card
        className="recruitment-card cursor-pointer transition-all duration-300 hover:scale-105 hover:bg-[#f78d2e] hover:shadow-xl"
        onClick={() => {
          navigate(`scheduling`);
        }}
      >
        <button className="modalBtn">
          <EllipsisOutlined className="dropdownIcon" />
        </button>
        <div className="flex flex-col items-center">
          <img src={Scheduling} alt="Your Logo" className="icon" />
          <div>
            <p className="cardDes font-bold text-xl">Scheduling</p>
          </div>
        </div>
      </Card>
      <Card className="recruitment-card  cursor-pointer transition-all duration-300 hover:scale-105 hover:bg-[#f78d2e] hover:shadow-xl" onClick={isVisible}>
        <button className="modalBtn">
          <EllipsisOutlined className="dropdownIcon" />
        </button>
        <div className="flex flex-col items-center">
          <img src={OfferLetter} alt="Your Logo" className="icon" />
          <div>
            <p className="cardDes font-bold text-xl">Offer Letter</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default RecruitmentCard;
RecruitmentCard.propTypes = {
  isVisible: PropTypes.func.isRequired,
};

